import type { EditorDoc } from "./doc-types";
import { slugifyHeading } from "@/lib/craft/headings";
import { docHeadingId } from "./doc-convert";

export type PageHeading = {
  id: string;
  text: string;
  level: 2 | 3;
};

function inlineText(content: unknown): string {
  if (typeof content === "string") return content.trim();
  if (!Array.isArray(content)) return "";
  return content
    .map((item) => {
      if (typeof item === "string") return item;
      if (item && typeof item === "object" && "text" in item) return String(item.text ?? "");
      return "";
    })
    .join("")
    .trim();
}

export function extractDocHeadings(doc: EditorDoc | null | undefined, tocLevel: "h2" | "h2-h3" = "h2"): PageHeading[] {
  if (!doc?.length) return [];
  const headings: PageHeading[] = [];

  for (const block of doc) {
    if (block.type !== "heading") continue;
    const level = Number((block.props as { level?: number })?.level ?? 2);
    if (level !== 2 && level !== 3) continue;
    const text = inlineText(block.content);
    if (!text) continue;
    headings.push({
      id: docHeadingId(text, block.props as Record<string, unknown>),
      text,
      level: level as 2 | 3,
    });
  }

  if (tocLevel === "h2") {
    return headings.filter((h) => h.level === 2);
  }
  return headings;
}

export { slugifyHeading };
